import { render, staticRenderFns } from "./errorMsg.vue?vue&type=template&id=5b0d672a&scoped=true&"
import script from "./errorMsg.vue?vue&type=script&lang=js&"
export * from "./errorMsg.vue?vue&type=script&lang=js&"
import style0 from "./errorMsg.vue?vue&type=style&index=0&id=5b0d672a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d672a",
  null
  
)

export default component.exports